import React, { useEffect } from "react";
import styled from "styled-components";
import { changeAndAddMetaTags } from "../utilities/helpers";
import PrivacyPolicyContent from "../components/PagesComponents/PrivacyPolicyContent";
const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  padding: 0.2rem;
`;

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
    changeAndAddMetaTags(
      "Privacy Policy | Extra Cash and Carry | London",
      "Privacy Policy | Extra Cash and Carry | London",
      document.URL
    );
  }, []);

  return (
    <Container>
      <PrivacyPolicyContent />
    </Container>
  );
};

export default PrivacyPolicy;
